import { SET_INVENTORY_COUNTS } from './types';

export const setInventoryCounts = (payload) => {
	return {
		payload,
		type: SET_INVENTORY_COUNTS
	};
};
